import React, { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './index.module.less'
import { ReactComponent as Back } from '@/assets/icons/back.svg'

interface IProps {
  title: ReactNode
  subTitle?: ReactNode
  back?: boolean
  children?: ReactNode
}

const PageHeader = ({ title, subTitle, back, children }: IProps) => {
  const navigate = useNavigate()

  return (
    <>
      <div className={styles.header}>
        <div className={styles.left}>
          {back && (
            <Back
              className={styles.back}
              onClick={() => {
                navigate(-1)
              }}
            />
          )}
          <div className={styles.title}>{title}</div>
          <div className={styles.subTitle}>{subTitle}</div>
        </div>
        {children}
      </div>
    </>
  )
}

export default PageHeader
